











import { Component, Vue } from "vue-property-decorator";
import headerTitle from "@/components/headerTitle.vue";
import goldConfig from "./model/goldConfig.vue";
import tradingCurrencyConfig from "./model/tradingCurrencyConfig.vue";
import { extractConfigInfo, extractConfig } from "@/req/moneyTx";

@Component({
  components: { headerTitle, goldConfig, tradingCurrencyConfig },
})
export default class Home extends Vue {
  public goldList: any = {
    close_money_extract: "",
    close_money_pay: "",
    explain: "",
    id: "",
    min_extarct_charge: "",
    min_extarct_ratio: "",
    min_extract_money: "",
    type: 1,
  };
  public tradingCurrencyList: any = {
    close_money_extract: "",
    close_money_pay: "",
    explain: "",
    id: "",
    min_extarct_charge: "",
    min_extarct_ratio: "",
    min_extract_money: "",
    account_time: "",
    type: 2,
  };
  public mounted() {
    this.getList();
  }
  public async getList() {
    const res = await extractConfigInfo({
      token: this.$fn.cookies.getToken("token"),
    });
    if (res.code == 0) {
      res.data.list.forEach((item) => {
        if (item.type == 1) {
          this.goldList = item;
        }
        if (item.type == 2) {
          this.tradingCurrencyList = item;
        }
      });
    }
  }
}
